/* eslint-disable */
// Here eslint disable is use to avoid line width error
import React from "react";

const Path = (props: { className?: string }) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="28.03"
    height="19.988"
    viewBox="0 0 28.03 19.988"
  >
    <path
      id="Tracé_6183"
      data-name="Tracé 6183"
      d="M26,18a4,4,0,0,0-3.858,3H18a3,3,0,0,1-3-3V14a4.951,4.951,0,0,0-1.026-3h8.168a4,4,0,1,0,0-2H9.858a4,4,0,1,0,0,2H10a3,3,0,0,1,3,3v4a5.006,5.006,0,0,0,5,5h4.142A3.993,3.993,0,1,0,26,18ZM26,8a2,2,0,1,1-2,2,2,2,0,0,1,2-2ZM6,12a2,2,0,1,1,2-2A2,2,0,0,1,6,12ZM26,24a2,2,0,1,1,2-2A2,2,0,0,1,26,24Z"
      transform="translate(-1.985 -6)"
      fill="currentColor"
    />
  </svg>
);

export { Path };
